/**
 * auth-service.js
 * Provides access to persisted auth/session data via a storage gateway.
 */
export class AuthService {
  constructor(gateway) {
    if (!gateway) {
      throw new Error('AuthService requires a persistence gateway');
    }
    this.gateway = gateway;
  }

  get() {
    return this.gateway.load();
  }

  save(patch) {
    return this.gateway.save(patch);
  }

  clear() {
    this.gateway.clear?.();
  }

  logout() {
    this.clear();
    return this.gateway.save ? this.gateway.save({ isLoggedIn: false }) : { isLoggedIn: false };
  }

  getToken() {
    return this.gateway.getToken?.() ?? null;
  }

  setToken(token) {
    if (typeof this.gateway.setToken === 'function') {
      this.gateway.setToken(token);
    }
  }

  startInactivityTracking() {
    if (typeof this.gateway.startInactivityTracking === 'function') {
      return this.gateway.startInactivityTracking();
    }
    return false;
  }

  stopInactivityTracking() {
    if (typeof this.gateway.stopInactivityTracking === 'function') {
      return this.gateway.stopInactivityTracking();
    }
    return false;
  }

  resetInactivityTimer() {
    if (typeof this.gateway.resetInactivityTimer === 'function') {
      return this.gateway.resetInactivityTimer();
    }
    return false;
  }

  checkAuthStatus(options) {
    if (typeof this.gateway.checkAuthStatus === 'function') {
      return this.gateway.checkAuthStatus(options);
    }
    return Promise.resolve(this.get());
  }
}
if (typeof window !== 'undefined') {
  window.AgileProServices = window.AgileProServices || {};
  window.AgileProServices.AuthService = AuthService;
}

